import { useConfig } from '../../../providers/envConfig'
import useFetch from '../../helpers/useFetch'

export type VerifyCodeResponse = {
  token: string
}

// usePostVerifyCode is a custom hook to fetch data from the /verification/verify-code endpoint.
const usePostVerifyCode = (id: string, code: string) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/verification/verify-code`
  const fields: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-BNET-KEY': envConfig.bnetKey,
    },
    credentials: 'include',
    body: JSON.stringify({ id: id, code: code }),
  }

  const { data, loading, error, callFetch } = useFetch<VerifyCodeResponse>(url, fields)

  return { data, loading, error, callFetch }
}

export default usePostVerifyCode
